<template>
  <div class="border row">
    <div class="col-12 card p-2 pb-0 filter">
      <div class="row w-100 pe-lg-0 me-1 py-2">
        <div class="col-md-4 col-12">
          <div class="mb-1">
            <label for="barcode_date">Date</label>
            <input v-model="form.date" class="form-control" id="barcode_date" type="date"/>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="mb-1">
            <label for="start_serial">Starting Serial</label>
            <input v-model="form.startSerial" class="form-control" id="start_serial" type="number" min="1"/>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="mb-1">
            <label for="quantity">Quantity</label>
            <input v-model="form.quantity" class="form-control" id="quantity" type="number" min="1"/>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="mb-1">
            <button @click="generateBarcodes" class="btn btn-secondary mt-1">Generate</button>
          </div>
        </div>
        <div v-if="generatedCodes.length > 0" class="col-md-4 col-12">
          <div class="mb-1">
            <button @click="goToPrint" class="btn btn-primary mt-1">Print</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div id="section-to-print">
        <div v-for="item in generatedCodes" :key="item.code" class="bg-sticker-border text-center">
          <div class="bg-l-height">
            <span class="bg-text-label">{{ item.code }}</span>
            <div class="bg-barcode-img" v-html="addSvgViewBox(item.barcode)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {reactive, ref} from "vue";
import handleBarcode from "@/services/modules/barcode";
import useDate from "@/services/utils/day";

const {fetchBarcodeBatch} = handleBarcode();
const {currentDate} = useDate();

const form = reactive({
  date: currentDate(),
  startSerial: 1,
  quantity: 1
});

const generatedCodes = ref([]);

const addSvgViewBox = (svg) => {
  if (! svg) return svg;

  const svgTagMatch = svg.match(/<svg[^>]*>/);
  if (! svgTagMatch) return svg;

  const svgTag = svgTagMatch[0];
  const widthMatch = svgTag.match(/width="([\d.]+)"/);
  const heightMatch = svgTag.match(/height="([\d.]+)"/);

  if (! widthMatch || ! heightMatch) return svg;

  const width = widthMatch[1];
  const height = heightMatch[1];
  let fixedSvgTag = svgTag;

  if (! svgTag.includes('viewBox')) {
    fixedSvgTag = fixedSvgTag.replace('<svg ', `<svg viewBox="0 0 ${width} ${height}" `);
  }

  fixedSvgTag = fixedSvgTag
    .replace(/width="[\d.]+"/, 'width="100%"')
    .replace(/height="[\d.]+"/, 'height="100%"');

  return svg.replace(svgTag, fixedSvgTag);
}

const generateBarcodes = async () => {
  if (! form.date) return;
  if (! form.startSerial || form.startSerial < 1) return;
  if (! form.quantity || form.quantity < 1) return;

  const res = await fetchBarcodeBatch({
    date: form.date,
    start_serial: form.startSerial,
    quantity: form.quantity
  });
  generatedCodes.value = res.items;
}

const goToPrint = () => {
  window.print();
}

</script>

<style>
.text-center {
  text-align: center;
}

.bg-text-label {
  font-size: 14px;
  display: block;
  margin: 3px
}

.bg-sticker-border {
  border: 0.1px dotted grey !important;
  overflow: hidden;
  box-sizing: border-box;
  width: 1.5in;
  height: 0.6in;
  display: inline-block;
  margin-bottom: 10px;
  text-align: center;
}

.bg-barcode-img {
  display: flex;
  justify-content: center;
}

.bg-l-height {
  line-height: 15px;
}

@media print {
  body * {
    visibility: hidden;
  }

  #section-to-print, #section-to-print * {
    visibility: visible;
  }

  #section-to-print {
    position: absolute;
    left: 0;
    top: 0;
    width: auto;
    height: auto;
  }

  .bg-sticker-border {
    display: block;
    width: 1.5in;
    height: 0.6in;
    margin: 0;
    padding: 2px;
    text-align: center;
    line-height: 12px;
    box-sizing: border-box;
    border: none !important;
    page-break-after: always;
    page-break-inside: avoid;
  }

  .bg-sticker-border:last-child {
    page-break-after: auto;
  }

  .bg-sticker-border .bg-text-label {
    display: block;
    margin: 0;
    padding: 0;
    font-size: 10px;
  }

  .bg-sticker-border .bg-barcode-img {
    width: 100% !important;
    height: auto !important;
  }
}

@page {
  margin: 0;
  size: 1.5in 0.6in;
}

.bg-barcode-img svg {
  width: 100% !important;
  height: auto !important;
}
</style>
